import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { AlertCircleIcon, FileIcon, UploadIcon } from "__barrel_optimize__?names=AlertCircleIcon,FileIcon,UploadIcon!=!lucide-react";
import { useCallback, useState } from 'react';
import { toast } from 'sonner';
export const FileUpload = (param)=>{
    let { onFileSelect } = param;
    const [isDragOver, setIsDragOver] = useState(false);
    const validateFile = (file)=>{
        if (file.type !== 'application/pdf') {
            toast.error("Invalid file type", {
                description: "Please select a PDF file."
            });
            return false;
        }
        // 50MB limit
        if (file.size > 50 * 1024 * 1024) {
            toast.error("File too large", {
                description: "Please select a PDF file smaller than 50MB."
            });
            return false;
        }
        return true;
    };
    const handleDrop = useCallback((e)=>{
        e.preventDefault();
        setIsDragOver(false);
        const files = Array.from(e.dataTransfer.files);
        const file = files[0];
        if (file && validateFile(file)) {
            onFileSelect(file);
        }
    }, [
        onFileSelect
    ]);
    const handleFileInput = (e)=>{
        var _e_target_files;
        const file = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
        if (file && validateFile(file)) {
            onFileSelect(file);
        }
    };
    return /*#__PURE__*/ _jsx(Card, {
        className: "relative overflow-hidden bg-upload-bg border-2 border-dashed border-upload-border hover:border-primary/50 transition-colors duration-200",
        children: /*#__PURE__*/ _jsx("div", {
            className: "p-12 text-center transition-colors duration-200 ".concat(isDragOver ? 'bg-upload-hover' : ''),
            onDrop: handleDrop,
            onDragOver: (e)=>{
                e.preventDefault();
                setIsDragOver(true);
            },
            onDragLeave: ()=>setIsDragOver(false),
            children: /*#__PURE__*/ _jsxs("div", {
                className: "space-y-6",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "mx-auto w-16 h-16 rounded-full flex items-center justify-center",
                        children: /*#__PURE__*/ _jsx(UploadIcon, {
                            className: "w-8 h-8 text-primary"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "text-xl font-semibold text-foreground",
                                children: "Upload PDF File"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-muted-foreground",
                                children: "Drag and drop your PDF file here, or click to browse"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                type: "file",
                                accept: ".pdf",
                                onChange: handleFileInput,
                                className: "hidden",
                                id: "file-upload"
                            }),
                            /*#__PURE__*/ _jsx("label", {
                                htmlFor: "file-upload",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    asChild: true,
                                    children: /*#__PURE__*/ _jsxs("span", {
                                        children: [
                                            /*#__PURE__*/ _jsx(FileIcon, {
                                                className: "w-4 h-4 mr-2"
                                            }),
                                            "Select PDF File"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-2 text-sm text-muted-foreground",
                                children: [
                                    /*#__PURE__*/ _jsx(AlertCircleIcon, {
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "Maximum file size: 50MB"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
